module.exports = __webpack_public_path__ + "img/Icon-60@3x.daae1fc8.png";